import { Constant, Headers } from "../apiConstants";

const PaymentSummaryAPI = async (orderId) => {
  const endpoint = Constant.PAYMENT_SUMMARY + `?orderId=${orderId}`;
  const BaseUrl = Constant.BASE_URL;
  try {
    const response = await fetch(BaseUrl + "/" + endpoint, {
      method: "get",
      headers: Headers,
    });
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default PaymentSummaryAPI;
